import { Component, ViewChild, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { NgForm } from '@angular/forms';
import * as ngswal from "sweetalert";
import { GlobalConstants } from '../common/global-constants';
import { customfunctions, DataParam } from '../common/customfunctions';
import { FileToUpload } from '../file-upload/file-to-upload.model';
import { ArticleMetaModel } from './articlemeta-model';
import { ApiMethod } from '../apimethods/api-method';
import { zip } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ArticleinfoComponent } from '../articleinfo/articleinfo.component';
declare var $;

@Component({
  selector: 'app-articlemeta',
  templateUrl: './articlemeta.component.html',
  styleUrls: ['./articlemeta.component.css']
})
/** Article component*/

export class ArticleMetaComponent {
  /** Article ctor */
  modelItem: ArticleMetaModel = new ArticleMetaModel();
  http: HttpClient;
  showModal: boolean;
  showInfoModal: boolean; showInfoMetadataModal: boolean;
  showAuthorModal: boolean;
  showFundingModal: boolean; showReopenModal: boolean;
  title: string;
  infoTitle: string;
  articleNotes: string;
  dataTable: any;
  dtAuthor: any;
  dtFunding: any;
  dtOptions: any;
  dtFile: any;
  nAuthIndex: number;
  nFundIndex: number;
  articleNo: string;
  articleTitle: string;
  articleSubTitle: string;
  articleType: string;
  authors: string;
  author: string;
  authorEMail: string;
  copyright: string;
  copyrightYear: string;
  volume: string;
  issue: string;
  pubDate: string;
  ePubDate: string;
  notes: string;
  isHold: boolean;
  holdType: string;
  license: string;
  public allocateUserId: boolean = false; showCorrepSelect: boolean = false;
  public allocatedId: string;
  public lVolumeList: any;
  public lSubjectList: any;
  public lArticleTypeList: any; articleTypeSelected: any;
  public lJournalList: any;
  public lStatusList: any; public lCorrectionTypeList: any;
  public lAuthorList: any;
  public lFundingList: any;
  public lFileList: string[] = [];
  public lSpecialIssueList: any; _specialIssueVal: any;
  public ISpecialIssueTitle: any;
  public lLanguageList: any; public lCountryList: any;
  fileBase64: string = "";
  articleId: number;
  tableData = [];
  fileToUpload: File = null;
  fileCount: number = 0;
  filePath: any;
  files: string[] = [];
  firstReleaseArticleId: string;
  @ViewChild('dataTable') table;
  @ViewChild('dtAuthor') dtTable;
  @ViewChild('dtFunding') dtFundingTable;
  @ViewChild('chkHold') chkHoldRelease;
  monthNames = ["Jan", "Feb", "Mar",
    "Apr", "May", "Jun",
    "Jul", "Aug", "Sep",
    "Oct", "Nov", "Dec"];
  dataSet: any;
  dataSetFunding: any;
  static unsaved = false;
  static pasteHtmlTextClear = false;

  public checkMetadataShow: boolean = GlobalConstants.CheckMetadataView('MetaData');
  ngOnInit() {
    $("#lstJournals").select2({
      placeholder: "Select Journal", dropdownParent: "#divMainFilter"
    }); $("#lstJournals").val([]).trigger("change");

    $("#lstVolume").select2({
      placeholder: "Select Volume", dropdownParent: "#divMainFilter"
    });
    $("#lstVolume").val([]).trigger("change");

    $("#lstIssue").select2({
      placeholder: "Select Issue", dropdownParent: "#divMainFilter"
    });
    $("#ddlDataField,#ddlPressPak").select2({
      placeholder: "All", dropdownParent: "#divMainFilter"
    });
    $("#ddlPublishedType,#ddlChangeVolIssue").select2({
      placeholder: "All", dropdownParent: "#modalReopen"
    });
    $("#lstIssue").val([]).trigger("change");

    $('#txtQueryMailBody,.ReviewPopup').jqte();

    this.UpdateTableHeight();

    ApiMethod.getBaseUrl();

    $('[name="changeValueMeta"]').change(function () {
      $('#txtPopPublDt').val($("#txtPublDt").val());
      $('#TxtPopVolume').val($("#txtVolume").val());
      $('#TxtPopIssue').val($("#txtIssue").val());
    });
  }

  ngAfterViewChecked(): void {
    if (localStorage.metadataEdit == 'true') {
      if (localStorage.metadisable != null) {
        $('#btnMetaUpdate').hide();
      }
      else {
        $('#btnMetaUpdate').show();
      }
      if ($('i[title="Reopen"]').length > 0) {
        $('i[title="Reopen"]').click(function () {
          $('#btnReopen').trigger('click');
        });
      }
    }
  }

  UpdateTableHeight() {
    $('#divArticleCT,#divStatusCT,#divStatusBody').css('height', GlobalConstants.size.height - 20);
    $('#divAuthorList,#divFundingList').css('height', (GlobalConstants.size.height - 155));
  }

  constructor(private router: Router) {
    ArticleMetaComponent.pasteHtmlTextClear = false;
    ApiMethod.getPageConfig().subscribe(
      data => {
        this.modelItem = <ArticleMetaModel>data["ArticlePage"];
        localStorage.aEID = 0;
        $('#ddlSubject,#ddlJournal,#ddlLanguage,#ddlCountry,#ddlArticleType,#ddlSpecialIssue')
          .select2({ placeholder: "Select", dropdownParent: "#divArticleInfoMetadata" });

        $('#ddlSpecialIssueTitle').select2({ placeholder: "Select", dropdownParent: "#divArticleInfoMetadata", tags: true });

        $('#ddlRole').select2({ placeholder: "Select", dropdownParent: "#myAuthorModal" });
        $('#ddlCorresAuthor').select2({ placeholder: "Select", dropdownParent: "#myAuthorModal" });

        this.getSubjectList();
        this.getJournalList();
        this.GetLanguageCountryList();
        this.getCorrectionTypeList();
        this.GetSpecialIssueTitle();

        this.lSpecialIssueList = [{ Type: 'Yes', Id: '1' }, { Type: 'No', Id: '0' }];

      }, error => {
        ngswal("Warning !", error.message, "warning");
      });
  }

  clearData(): void {
    try {
      let form: NgForm = $('form#frmMain');
      form[0].reset();
      let form1: NgForm = $('form#frmAuthor');
      form1[0].reset();
      let form2: NgForm = $('form#frmFundingInfo');
      form2[0].reset();

      $('a[href="#MainTab"]').click();
    } catch (e) {
      console.log(e);
    }

  }

  hide() {
    this.clearData();
    this.showModal = false;
  }

  hideAuthorModal(): void {
    this.showAuthorModal = false;
    ArticleMetaComponent.unsaved = false;
  }

  addAuthor() {
    this.clearAuthorDetails();
    $("#btnUpdateAuthor").html("Add");
    this.showAuthorModal = true;
  }

  deleteAuthorDetails(author: any, authorIndex: number): void {
    this.lAuthorList.splice(authorIndex - 1, 1);
    this.clearAuthorDetails();
  }

  clearAuthorDetails(): void {
    this.nAuthIndex = 0;
    $("#txtSurname").val("");
    $("#txtMiddleName").val("");
    $("#txtGivenName").val("");
    $("#txtContribute").val("");
    $("#txtContributeType").val("");
    $("#txtAuthorEmail").val("");
    $("#ddlCorresAuthor").val("false").change();
    $("#btnAuthorAdd").css("display", "");
    $("#btnAuthorUpdate").css("display", "none");
    $("#ddlAuthorList").val(0).change();

  }

  showAuthorDetails(author: any, authIndex: number): void {
    //Corresponding author set logic
    $('#ddlAuthorList').find('option').css('display', '');
    $('#ddlAuthorList').find('option[value=' + author.ID + ']').css('display', 'none');
    this.authorList = author;
    this.showCorrepSelect = false;
    $("#ddlAuthorList").val(0).change();
    //Corresponding author set logic

    this.nAuthIndex = authIndex;
    $("#txtSurname").val(author.Surname);
    $("#txtMiddleName").val(author.Middlename);
    $("#txtGivenName").val(author.Given_names);
    $("#txtContribute").val(author.Contrib_id);
    $("#txtContributeType").val(author.Contrib_id_type);
    $("#txtAuthorEmail").val(author.Email);
    if ((author.Corresp) === true) {
      $("#ddlCorresAuthor").val("true").change();
    } else {
      $("#ddlCorresAuthor").val("false").change();
    }

    $("#ddlRole").val(author.Content_type).change();
    $("#txtContribType").val(author.Contrib_type);
    $("#txtAuORCID").val(author.ORCID);
    $("#txtAURinggoldId").val(author.RinggoldId);
    $("#txtAuRinggoldInstitution").val(author.RinggoldInstitution);
    $("#txtAuAddress1").val(author.Address1);
    $("#txtAuAddress2").val(author.Address2);
    $("#txtAuCity").val(author.City);
    $("#txtAuState").val(author.State);
    $("#txtAuCountry").val(author.Country);
    $("#txtAuPostalCode").val(author.PostalCode);

    $("#btnAuthorAdd").css("display", "none");
    $("#btnAuthorUpdate").css("display", "");
    $("#btnUpdateAuthor").html("Update");
    this.showAuthorModal = true;
  }

  updateAuthorDetails() {

    if (this.nAuthIndex == 0) {
      if ($("#txtSurname").val().trim() == "") {
        ngswal("Warning !", "Enter Surname !", "warning");
        return false;
      }
      else if ($("#txtGivenName").val().trim() == "") {
        ngswal("Warning !", "Enter GivenName !", "warning");
        return false;
      }
      else if ($("#txtAuthorEmail").val().trim() == "") {
        ngswal("Warning !", "Enter Email !", "warning");
        return false;
      }
      else if ($("#ddlRole").val() == "Select") {
        ngswal("Warning !", "Please Select Content Type !", "warning");
        return false;
      }
      else if ($("#txtContribType").val().trim() == "") {
        ngswal("Warning !", "Please Select Contrib Type !", "warning");
        return false;
      }
      else {
        let blnAuthCorres: boolean;
        if (($("#ddlCorresAuthor").val()) === "true") {
          blnAuthCorres = true;
        } else {
          blnAuthCorres = false;
        }
        let newRow: any = {};
        newRow = {
          Surname: $("#txtSurname").val(),
          Middlename: $("#txtMiddleName").val(),
          Given_names: $("#txtGivenName").val(),
          Contrib_id: $("#txtContribute").val(),
          Contrib_id_type: $("#txtContributeType").val(),
          Email: $("#txtAuthorEmail").val(),
          Corresp: blnAuthCorres,
          Content_type: $("#ddlRole").val(),
          ORCID: $("#txtAuORCID").val(),
          RinggoldId: $("#txtAuRinggoldId").val(),
          RinggoldInstitution: $("#txtAuRinggoldInstitution").val(),
          Address1: $("#txtAuAddress1").val(),
          Address2: $("#txtAuAddress2").val(),
          City: $("#txtAuCity").val(),
          State: $("#txtAuState").val(),
          Country: $("#txtAuCountry").val(),
          PostalCode: $("#txtAuPostalCode").val(),
          ID: 0
        };
        this.lAuthorList.push(newRow);
        this.clearAuthorDetails();
      }
    }
    else {
      if ($("#txtSurname").val().trim() == "") {
        ngswal("Warning !", "Enter Surname !", "warning");
        return false;
      }
      else if ($("#txtGivenName").val().trim() == "") {
        ngswal("Warning !", "Enter Givenname !", "warning");
        return false;
      }
      else if ($("#txtAuthorEmail").val().trim() == "") {
        ngswal("Warning !", "Enter Email !", "warning");
        return false;
      }
      else if ($("#ddlRole").val() == "Select") {
        ngswal("Warning !", "Please Select Content Type !", "warning");
        return false;
      }
      else if ($("#txtContribType").val().trim() == "") {
        ngswal("Warning !", "Please Select Contrib Type !", "warning");
        return false;
      }
      else if ($('#ddlCorresAuthor').val() == 'false' && $('#ddlAuthorList').val() == 0 && this.showCorrepSelect == true) {
        ngswal("Warning !", "Please select atleast one corresponding author !", "warning");
        return false;
      }
      else {
        this.lAuthorList[this.nAuthIndex - 1].Surname = $("#txtSurname").val();
        this.lAuthorList[this.nAuthIndex - 1].Middlename = $("#txtMiddleName").val();
        this.lAuthorList[this.nAuthIndex - 1].Given_names = $("#txtGivenName").val();
        this.lAuthorList[this.nAuthIndex - 1].Contrib_id = $("#txtContribute").val();
        this.lAuthorList[this.nAuthIndex - 1].Contrib_id_type = $("#txtContributeType").val();
        this.lAuthorList[this.nAuthIndex - 1].Content_type = $("#ddlRole").val();
        this.lAuthorList[this.nAuthIndex - 1].Email = $("#txtAuthorEmail").val();
        this.lAuthorList[this.nAuthIndex - 1].Contrib_type = $("#txtContribType").val();
        this.lAuthorList[this.nAuthIndex - 1].ORCID = $("#txtAuORCID").val();
        this.lAuthorList[this.nAuthIndex - 1].RinggoldId = $("#txtAURinggoldId").val();
        this.lAuthorList[this.nAuthIndex - 1].RinggoldInstitution = $("#txtAuRinggoldInstitution").val();
        this.lAuthorList[this.nAuthIndex - 1].Address1 = $("#txtAuAddress1").val();
        this.lAuthorList[this.nAuthIndex - 1].Address2 = $("#txtAuAddress2").val();
        this.lAuthorList[this.nAuthIndex - 1].City = $("#txtAuCity").val();
        this.lAuthorList[this.nAuthIndex - 1].State = $("#txtAuState").val();
        this.lAuthorList[this.nAuthIndex - 1].Country = $("#txtAuCountry").val();
        this.lAuthorList[this.nAuthIndex - 1].PostalCode = $("#txtAuPostalCode").val();

        if (($("#ddlCorresAuthor").val()) === "true") {
          this.lAuthorList[this.nAuthIndex - 1].Corresp = true;
        } else {
          this.lAuthorList[this.nAuthIndex - 1].Corresp = false;
        }

        if (this.showCorrepSelect == true) {
          this.updateCorresValue();
        }

        this.clearAuthorDetails();
      }
    }
    this.showAuthorModal = false;
  }

  hideFundingModal(): void {
    this.showFundingModal = false;
  }

  addFunding() {
    this.clearFundingDetails();
    $("#btnUpdateFunding").html("Add");
    this.showFundingModal = true;
  }

  deleteFundingDetails(funding: any, fundingIndex: number): void {
    this.lFundingList.splice(fundingIndex - 1, 1);
    this.clearFundingDetails();
  }

  clearFundingDetails(): void {
    this.nFundIndex = 0;
    $("#txtAwardGroupId").val("");
    $("#txtAwardId").val("");
    $("#txtInstitutionType").val("");
    $("#txtInstitutionId").val("");
    $("#txtInstitution").val("");
  }

  showFundingDetails(funding: any, fundingIndex: number): void {
    this.nFundIndex = fundingIndex;
    $("#txtAwardGroupId").val(funding.AwardGroupId);
    $("#txtAwardId").val(funding.AwardId);
    $("#txtInstitutionType").val(funding.InstitutionIdType);
    $("#txtInstitutionId").val(funding.InstitutionId);
    $("#txtInstitution").val(funding.Institution);
    $("#btnUpdateFunding").html("Update");
    this.showFundingModal = true;
  }

  updateFundingDetails() {

    if (this.nFundIndex == 0) {
      if ($("#txtAwardGroupId").val().trim() == "") {
        ngswal("Warning !", "Enter Award Group Id !", "warning");
        return false;
      }
      else if ($("#txtAwardId").val().trim() == "") {
        ngswal("Warning !", "Enter Award Id !", "warning");
        return false;
      }
      else if ($("#txtInstitutionType").val().trim() == "") {
        ngswal("Warning !", "Enter Institution Type !", "warning");
        return false;
      }
      else if ($("#txtInstitutionId").val().trim() == "") {
        ngswal("Warning !", "Enter Institution Id !", "warning");
        return false;
      }
      else if ($("#txtInstitution").val().trim() == "") {
        ngswal("Warning !", "Enter Institution !", "warning");
        return false;
      }
      else {

        let newRow: any = {};
        newRow = { AwardGroupId: $("#txtAwardGroupId").val(), AwardId: $("#txtAwardId").val(), InstitutionId: $("#txtInstitutionId").val(), InstitutionIdType: $("#txtInstitutionType").val(), Institution: $("#txtInstitution").val(), ID: 0 };
        this.lFundingList.push(newRow);
        this.clearFundingDetails();
      }

    }
    else {
      if ($("#txtAwardGroupId").val().trim() == "") {
        ngswal("Warning !", "Enter Award Group Id !", "warning");
        return false;
      }
      else if ($("#txtAwardId").val().trim() == "") {
        ngswal("Warning !", "Enter Award Id !", "warning");
        return false;
      }
      else if ($("#txtInstitutionType").val().trim() == "") {
        ngswal("Warning !", "Enter Institution Type !", "warning");
        return false;
      }
      else if ($("#txtInstitutionId").val().trim() == "") {
        ngswal("Warning !", "Enter Institution Id !", "warning");
        return false;
      }
      else if ($("#txtInstitution").val().trim() == "") {
        ngswal("Warning !", "Enter Institution !", "warning");
        return false;
      }
      else {
        this.lFundingList[this.nFundIndex - 1].AwardGroupId = $("#txtAwardGroupId").val();
        this.lFundingList[this.nFundIndex - 1].AwardId = $("#txtAwardId").val();
        this.lFundingList[this.nFundIndex - 1].InstitutionId = $("#txtInstitutionId").val();
        this.lFundingList[this.nFundIndex - 1].InstitutionIdType = $("#txtInstitutionType").val();
        this.lFundingList[this.nFundIndex - 1].Institution = $("#txtInstitution").val();

        this.clearFundingDetails();
      }
    }
    this.showFundingModal = false;
  }


  allocate(): void {

    if (this.allocateUserId) {
      this.allocateUserId = false;
      return;
    }
    if (localStorage.rowIdVal != "") {
      if (localStorage.colName != "Allocation") {
        ngswal({
          title: "Update Confirmation !",
          text: "Do you want to update the " + localStorage.colName + " value ?",
          type: "info",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Yes, Update!",
          cancelButtonText: "No, Cancel!",
          closeOnConfirm: false,
          closeOnCancel: false
        },
          function (isConfirm) {
            if (isConfirm) {
              $("#LoadingImage").show();
              $('#btnArticleAllocate').trigger("click");
            } else {
              $('input[data-idavalue="' + localStorage.rowIdVal + '"][data-colname="' + localStorage.colName + '"]').
                prop('checked', (localStorage.dropId == '0' ? true : false));
              ngswal("Cancelled !", "You clicked cancel! :)", "warning");
            }
          });

      }
      else {
        var tranStatus = "";
        var userID = "";
        var articleData = {
          ArticleId: localStorage.rowIdVal
        };

        ApiMethod.postMethod(this.modelItem.transactionApi, articleData).subscribe(
          result => {

            let itemL = result.aTransItem;
            tranStatus = itemL[0].Status;
            userID = itemL[0].UserID;
            this.allocatedId = userID;
            if (tranStatus == "InProcess") {
              ngswal("Failed !", "Article already in process. you can't allocate this article", "warning");
              this.allocateUserId = true;
              $('select[data-idavalue="' + localStorage.rowIdVal + '"]').val(userID).change();
              $("#LoadingImage").hide();

            }
            else {
              ngswal({
                title: "Are you confirm to allocate article?",
                text: "Article Allocate Confirmation !",
                type: "info",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Yes, Allocate!",
                cancelButtonText: "No, Cancel!",
                closeOnConfirm: false,
                closeOnCancel: false
              },
                function (isConfirm) {
                  if (isConfirm) {
                    $('#btnArticleAllocate').trigger("click");
                  } else {
                    ngswal("Cancelled !", "You clicked cancel! :)", "warning");
                    $('#btnArticleAllocateCancel').trigger("click");

                  }
                });

              $("#LoadingImage").hide();
            }
          },
          error => {
            ngswal("Failed !", error.message, "warning");
            $("#LoadingImage").hide();
          }
        );
      }
    }
  }

  articleAllocateCancel() {
    this.allocateUserId = true;
    $('select[data-idavalue="' + localStorage.rowIdVal + '"]').val(this.allocatedId).change();
    $("#LoadingImage").hide();
    return false;
  }
  articleAllocate() {
    $("#LoadingImage").show();
    var aItemL = {
      LoginId: localStorage.aLoginID,
      ArticleId: localStorage.rowIdVal,
      AllocateUserId: localStorage.dropId,
      ColName: localStorage.colName,
      ColNameValue: localStorage.colNameValue
    }
    ApiMethod.postMethod(this.modelItem.allocationApi, aItemL).subscribe(
      result => {
        if (result.status) {
          ngswal({
            position: 'top-end',
            type: "success",
            title: "Status Updated",
            text: result.message,
            showConfirmButton: false,
            timer: 1500
          });
          $("#LoadingImage").hide();
        } else {
          $("#LoadingImage").hide();
          ngswal("Failed !", result.message, "warning");
        }
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "warning");
      });
  }

  getPopUpData(): void {
    if (localStorage.aEID != "") {
      $("#LoadingImage").show();
      var articleData = {
        ArticleId: localStorage.aEID
      };
      ApiMethod.postMethod(this.modelItem.articleInfoByNoApi, articleData).subscribe(
        result => {
          this.lVolumeList = result.aJrnlVolIss;
          let newRow: any = {};
          newRow = { Volume: "" };
          this.lVolumeList.unshift(newRow);
          let itemL = result.aArticleItem;
          this.articleNo = itemL.ArticleNo;
          this.articleTitle = itemL.ArticleTitle;
          this.articleType = (itemL.ArticleType == null ? "" : itemL.ArticleType);
          this.author = (itemL.Authors == null ? "" : itemL.Authors);
          this.authorEMail = (itemL.AuthorEmail == null ? "" : itemL.AuthorEmail);
          this.copyright = (itemL.Copyright == null ? "" : itemL.Copyright);
          this.copyrightYear = (itemL.CopyrightYear == null ? "" : itemL.CopyrightYear);
          this.volume = (itemL.Volume == null ? "" : itemL.Volume);
          this.issue = (itemL.Issue == null ? "" : itemL.Issue);
          this.pubDate = GlobalConstants.FormatDate(itemL.PubDate, 0);
          this.ePubDate = GlobalConstants.FormatDate(itemL.EPubDate, 0);
          this.notes = (itemL.Notes == null ? "" : itemL.Notes);
          this.isHold = (itemL.IsHold == null ? false : itemL.IsHold);
          this.license = (itemL.License == null ? "" : itemL.License);
          $("#LoadingImage").hide();
        },
        error => {
          ngswal("Failed !", error.message, "warning");
          $("#LoadingImage").hide();
        }
      );
    }
  }

  //Show Article status
  showInfoPopUp(): void {
    this.PopulateArticleStatus();
    this.PopuplateArticleMetada();
  }

  //Show Article metaData
  show(): void {
    this.PopulateArticleStatus();
    this.PopuplateArticleMetada();
  }

  //Hide Article Status model
  hideInfoModal(): void {
    this.showInfoModal = false;
  }

  PopulateArticleStatus() {
    if (localStorage.dtColName == 'RelatedArticleType') {

      $("#LoadingImageMeta").show();
      var articleData = {
        ArticleId: localStorage.aEID
      };

      ApiMethod.postMethod(this.modelItem.relatedArticleApi, articleData).subscribe(
        result => {
          if (result.status == 'Success') {
            ArticleinfoComponent.ArticleInfo(result.message);
            //this.showInfoModal = true;
            this.showInfoMetadataModal = true;
            $("#LoadingImagePopup").hide();
          }
          else {
            ngswal("Failed !", "Related Article Type DOI does not exist.", "warning");
          }
        },
        error => {
          ngswal("Failed !", error.message, "warning");
          $("#LoadingImageMeta").hide();
        }
      );

    }
    else {
      ArticleinfoComponent.ArticleInfo(localStorage.aEID);
      this.showInfoMetadataModal = true;
    }

  }

  PopuplateArticleMetada() {
    try {
      ArticleMetaComponent.unsaved = false;
      localStorage.removeItem('metadisable');
      $("#divArticleModule :input").removeAttr("disabled");
      this.clearData();
      $("#LoadingImageMeta").show();
      var articleData = {
        ArticleId: localStorage.aEID
      };
      ApiMethod.postMethod(this.modelItem.articleByIdApi, articleData).subscribe(
        result => {

          $('#frmMain,#frmSecondary,#frmAuthor,#frmFunding').css('height', GlobalConstants.size.height - 170);
          let itemL = result.aArticleItem;

          this.getFieldConfigList(itemL[0].JournalID);

          $("#txtTitle").val(itemL[0].ArticleTitle);
          $("#txtArticleID").val(itemL[0].ArticleNo);
          $("#ddlJournal").val(itemL[0].JournalID).change();
          $("#ddlLanguage").val(itemL[0].Language).change();
          $("#ddlCountry").val(itemL[0].Country).change();
          this.articleTypeSelected = itemL[0].ArticleTypeId;
          $("#ddlArticleType").val(itemL[0].ArticleTypeId).change();

          $("#ddlSubject").val(itemL[0].Subject).change();
          $("#txtTargetDateDt").val(itemL[0].TargetDate);
          $("#txtReceivedDt").val(GlobalConstants.SetValue_FormatDate(itemL[0].ReceivedDate));
          $("#txtScheduleDt").val(GlobalConstants.SetValue_FormatDate(itemL[0].ScheduleDate));
          $("#txtDueDt").val(GlobalConstants.SetValue_FormatDate(itemL[0].DueDate));
          $("#txtPublDt").val(GlobalConstants.SetValue_FormatDate(itemL[0].PubDate));
          $("#txtEPublDt").val(GlobalConstants.SetValue_FormatDate(itemL[0].EPubDate));
          $("#txtPeerReview").val(GlobalConstants.SetValue_FormatDate(itemL[0].HistoryReceived));
          $("#txtAcceptedPublDt").val(GlobalConstants.SetValue_FormatDate(itemL[0].HistoryAccepted));
          $("#txtHistoryRevisedDt").val(GlobalConstants.SetValue_FormatDate(itemL[0].HistoryRevised));
          $("#txtElocator").val(itemL[0].Elocator);
          $("#txtCopyright").html(itemL[0].Copyright);
          $("#txtLicense").val(itemL[0].License);
          $("#txtVolume").val(itemL[0].Volume);
          $("#txtIssue").val(itemL[0].Issue);
          $("#txtManuscript").val(itemL[0].Manuscript);
          $("#txtDOI").val(itemL[0].DOI);
          $("#txtMsPage").val(itemL[0].MSPage);
          $("#txtProofPage").val(itemL[0].ProofPage);
          $("#txtStartPage").val(itemL[0].StartPage);
          $("#txtEndPage").val(itemL[0].EndPage);
          $("#txtShortTitle").val(itemL[0].ArticleShortTitle);
          $("#txtTableCnt").val(itemL[0].TableCount);
          $("#txtWordCount").val(itemL[0].WordCount);
          $("#txtColorFig").val(itemL[0].ColorFigCount);
          $("#txtBWFig").val(itemL[0].BWFigCount);
          $("#txtTotalFig").val(itemL[0].FigCount);
          $("#txtEditorSummary").val(itemL[0].EditorSummary);
          $("#txtProductionNotes").val(itemL[0].ProductionNotes);
          $("#txtFunding").val(itemL[0].Funding);
          $("#txtOverline").val(itemL[0].Overline);
          $("#txtAbstract").val(itemL[0].Abstract);
          $("#txtTeaser").val(itemL[0].Teaser);
          $("#txtProductionNotes").val(itemL[0].ProductionNotes);
          $("#txtRelatedArticleType").val(itemL[0].RelatedArticleType);
          $("#txtFirstReleaseDate").val(GlobalConstants.SetValue_FormatDate(itemL[0].FirstReleaseDate));
          $("#txtHandlingEditor").val(itemL[0].HandlingEditor); // handling editor

          this._specialIssueVal = (itemL[0].SpecialIssue ? 1 : 0);
          $("#ddlSpecialIssue").val(this._specialIssueVal).change();
          $("#ddlSpecialIssueTitle").val(itemL[0].SpecialIssueTitle).change();

          this.dataSet = JSON.stringify(result.aAuthorItem); // Data List
          this.dataSet = JSON.parse(this.dataSet);

          //Load Author and Funding If available of Metadata Edit
          try {
            this.dtAuthor = $(this.dtTable.nativeElement);
            this.lAuthorList = result.aAuthorItem;
            this.lFundingList = result.aFundingItem;
          } catch (e) {
          }

          $('#btnReopen').hide();
          //Disabled once article Approved
          if (itemL[0].IsApprove) {

            if (!itemL[0].AlwaysEditMetadata) {
              localStorage.metadisable = itemL[0].IsApprove;
            }

            if (this.lCorrectionTypeList.length > 0) {
              $('#btnReopen').show();
            }
          }
          //this.showModal = true;
          $("#LoadingImageMeta").hide();

          ArticleMetaComponent.unsaved = false;
          $('#ArtMetadata :input:not(#ddlSpecialIssueTitle)').change(function () { //triggers change in all input fields including text type
            ArticleMetaComponent.unsaved = true;
          });

          this.DisabledInutContorls();
        },
        error => {
          ngswal("Failed !", error.message, "warning");
          $("#LoadingImageMeta").hide();
        }
      );

      $('#divStatusCT').css('height', (GlobalConstants.size.height + 60));

      this.title = "Article Metadata Editing";
    } catch (e) {
      console.log(e);
      $("#LoadingImageMeta").hide();
    }
  }

  //Update Article Details
  updateArticleDetails() {

    if ($("#txtTitle").val() == "") {
      ngswal("Warning !", "Enter Title !", "warning");
      return false;
    }
    else if ($("#txtArticleID").val() == "") {
      ngswal("Warning !", "Enter Article Number!", "warning");
      return false;
    }
    else if ($("#ddlJournal").val() == "0") {
      ngswal("Warning !", "Select Journal!", "warning");
      return false;
    }
    else if ($("#ddlArticleType").val() == null) {
      ngswal("Warning !", "Select Article Type!", "warning");
      return false;
    }
    else if ($("#txtReceivedDt").val() == "") {
      ngswal("Warning !", "Select Received Date!", "warning");
      return false;
    }
    else if ($("#txtManuscript").val() == "") {
      ngswal("Warning !", "Enter Manuscript!", "warning");
      return false;
    }
    else {
      $("#LoadingImageMeta").show();
      let _specialIssue = ($("#ddlSpecialIssue").val() == 1 ? true : false);
      let _specialIssueTitle = '';
      if ($('#chkIsSpecialToNormal').is(':checked')) {
        if ($("#ddlSpecialIssueTitle").val() != null) {
          _specialIssueTitle = $("#ddlSpecialIssueTitle").val();
        }
      }
      var aArticleItemL = {
        ID: localStorage.aEID,
        ArticleTitle: $("#txtTitle").val(),
        ArticleNo: $("#txtArticleID").val(),
        JournalID: $("#ddlJournal").val(),
        Subject: $("#ddlSubject").val(),
        ArticleType: $("#ddlArticleType").val(),
        ReceivedDate: $("#txtReceivedDt").val(),
        ScheduleDate: $("#txtScheduleDt").val(),
        DueDate: $("#txtDueDt").val(),
        PubDate: $("#txtPublDt").val(),
        EPubDate: $("#txtEPublDt").val(),
        Volume: $("#txtVolume").val(),
        Issue: $("#txtIssue").val(),
        SpecialIssue: _specialIssue,
        SpecialIssueTitle: _specialIssueTitle,
        FirstReleaseDate: $("#txtFirstReleaseDate").val(),
        Manuscript: $("#txtManuscript").val(),
        DOI: $("#txtDOI").val(),
        MSPage: $("#txtMsPage").val(),
        ProofPage: $("#txtProofPage").val(),
        StartPage: $("#txtStartPage").val(),
        EndPage: $("#txtEndPage").val(),
        ArticleShortTitle: $("#txtShortTitle").val(),
        TableCount: $("#txtTableCnt").val(),
        WordCount: $("#txtWordCount").val(),
        ColorFigCount: $("#txtColorFig").val(),
        BWFigCount: $("#txtBWFig").val(),
        FigCount: $("#txtTotalFig").val(),
        EditorSummary: $("#txtEditorSummary").val(),
        Funding: $("#txtFunding").val(),
        Overline: $("#txtOverline").val(),
        Abstract: $("#txtAbstract").val(),
        Teaser: $("#txtTeaser").val(),
        ProductionNotes: $("#txtProductionNotes").val(),
        Copyright: $("#txtCopyright").html(),
        License: $("#txtLicense").val(),
        HistoryReceived: $("#txtPeerReview").val(),
        HistoryAccepted: $("#txtAcceptedPublDt").val(),
        HistoryRevised: $("#txtHistoryRevisedDt").val(),
        RelatedArticleType: $("#txtRelatedArticleType").val(),
        UpdatedBy: localStorage.aLoginID,
        AuthorList: JSON.stringify(this.lAuthorList),
        FundingList: JSON.stringify(this.lFundingList),
        HandlingEditor: $("#txtHandlingEditor").val(), // handling editor
        TargetDate: $("#txtTargetDateDt").val(),
        Language: $("#ddlLanguage").val(),
        Country: $("#ddlCountry").val(),
      };
      let aItemP = JSON.stringify(aArticleItemL);

      ApiMethod.postMethod(this.modelItem.updateArticleApi, aItemP).subscribe(
        response => {
          if (response.status == "Failed" || response.status == "Failed ") {
            ngswal("Failed !", response.message, "error");
          } else {
            ngswal({
              position: "top-end",
              type: "success",
              title: "Updated!",
              text: response.message,
              showConfirmButton: false,
              timer: 1500
            });
          }
          if ($("#btnRefreshLoadData").length > 0) {
            $("#btnRefreshLoadData").trigger("click");
          }
          if ($("#btnAutoRefreshDash").length > 0) {
            $("#btnAutoRefreshDash").trigger("click");
          }
          $("#LoadingImageMeta").hide();
          this.GetSpecialIssueTitle();
          //Call Data Post to Client Api
          //this.ClientApiDataPost(localStorage.aEID);
          ArticleMetaComponent.unsaved = false;
        },
        error => {
          ngswal("Failed !", error.error.Message, "warning");
          $("#LoadingImageMeta").hide();
        }
      );

    }
  }

  //Data post to client api
  ClientApiDataPost(articleId): void {
    ApiMethod.getMethod(this.modelItem.ClientApiCall + '/' + articleId + '/' + localStorage.aLoginID).subscribe(
      result => {
        //Author and Funder data post
        ApiMethod.getMethod(this.modelItem.ClientApiCallAF + '/' + articleId + '/' + localStorage.aLoginID).subscribe(
          reponse => {
            console.log(reponse);
          },
          error => {
            console.log(error.message);
          }
        );
      },
      error => {
        console.log(error.message);
      }
    );


  }

  public GetSpecialIssueTitle(): void {

    ApiMethod.getMethod(this.modelItem.specialissuetitleApi + '/' + localStorage.aLoginID + '/' + localStorage.aPubID).subscribe(
      result => {
        $("#LoadingImage").hide();
        this.ISpecialIssueTitle = result.specialIssueTitle;
        localStorage.specialissuetitle = JSON.stringify(this.ISpecialIssueTitle);
      },
      error => {
        ngswal("Failed !", error.message, "warning");
      }
    );

  }


  public getSubjectList(): void {

    ApiMethod.getMethod(this.modelItem.articleSubjectApi).subscribe(
      result => {
        $("#LoadingImage").hide();
        this.lSubjectList = result.aArticleSubjects;

      },
      error => {
        ngswal("Failed !", error.message, "warning");
      }
    );

  }

  public getArticleTypeList(articletypeId = 0): void {
    ApiMethod.getMethod(this.modelItem.articleTypeApi + '/' + $('#ddlJournal').val()).subscribe(
      result => {
        $("#LoadingImage").hide();
        this.lArticleTypeList = result.aArticleTypes;
      },
      error => {
        ngswal("Failed !", error.message, "warning");
      }
    );

  }

  public getStatusList(): void {

    ApiMethod.getMethod(this.modelItem.statusListApi).subscribe(
      result => {
        $("#LoadingImage").hide();
        this.lStatusList = result.aArticleStatus;
      },
      error => {
        ngswal("Failed !", error.message, "warning");
      }
    );
  }

  public getCorrectionTypeList(): void {

    ApiMethod.getMethod(this.modelItem.CorrectionTypeList + '/' + localStorage.aPubID).subscribe(
      result => {
        $("#LoadingImage").hide();
        this.lCorrectionTypeList = result.aCorrTypeitem;
      },
      error => {
        console.log(error.message);
      }
    );
  }

  public getJournalList(): void {
    var aItemL = {
      PublisherID: localStorage.aPubID
    }
    ApiMethod.postMethod(this.modelItem.journalListApi, aItemL).subscribe(
      result => {
        $("#LoadingImage").hide();
        this.lJournalList = result.aJournalList;

      },
      error => {
        ngswal("Failed !", error.message, "warning");
      }
    );
  }

  public GetLanguageCountryList(): void {
    ApiMethod.getMethod(this.modelItem.LanguageCountryListApi).subscribe(
      result => {
        this.lLanguageList = result.LanguageList;
        this.lCountryList = result.CountryList;
      },
      error => {
        ngswal("Failed !", error.message, "warning");
      }
    );
  }

  setDateValues() {
    var now = new Date();

    var currentDay = ("0" + now.getDate()).slice(-2);
    var currentMonth = ("0" + (now.getMonth() + 1)).slice(-2);
    var currentDate = now.getFullYear() + "-" + (currentMonth) + "-" + (currentDay);
    $('#Txt_ToDate').val(currentDate);

    var preDate = new Date(now.setDate(now.getDate() - 7));
    var prevDay = ("0" + (preDate.getDate())).slice(-2);
    var prevMonth = ("0" + (preDate.getMonth() + 1)).slice(-2);
    var prevToday = preDate.getFullYear() + "-" + (prevMonth) + "-" + (prevDay);
    $("#Txt_FromDate").val(prevToday);
  }

  authorList: any;
  CheckCorrespSelect(): void {
    let correspCount = 0;
    $("#tblAuthorList tbody tr").each(function () {
      //Check lightblue 
      if ($(this).css("background-color") == "rgb(173, 216, 230)") {
        correspCount++;
      }
    });
    this.showCorrepSelect = false;
    if ($('#ddlCorresAuthor').val() == 'false' && this.authorList.Corresp == true) {
      if (correspCount <= 1) {
        this.showCorrepSelect = true;
      }
    }
  }
  updateCorresValue() {
    let index = this.findAuthorList($('#ddlAuthorList').val());
    if (($("#ddlAuthorList").val()) != "0") {
      this.lAuthorList[index].Corresp = true;
    }
  }

  findAuthorList(id) {
    let index;
    this.lAuthorList.findIndex(function (item, i) {
      if (item.ID == id) {
        index = i;
        return true;
      }
    });
    return index;
  }

  getFieldConfigList(journalId) {
    let pubId = localStorage.aPubID;
    ApiMethod.getMethod(this.modelItem.FieldConfigList + "/Tbl_Articles" + "/" + journalId + '/' + pubId).subscribe(
      result => {
        let itemList = result.fieldList;
        $(itemList).each(function (index, val) {
          $("#divLoadData :input").removeAttr("disabled");
          let field = $('#ArtMetadata [name="' + val.TableField + '"]');
          $(field).find('input,select,textarea').removeAttr("disabled");
          if (val.IsVisible) {
            $(field).show();
            $(field).find('label').html(val.LabelName);
            $(field).find('input').attr('maxlength', val.CharLength);
            if (val.IsEditable == false) {
              $(field).find('input,select,textarea').attr('disabled', 'disabled');
              $(field).filter('button,th,td,i').hide();
            }
          }
          else {
            $(field).hide();
          }
          if (localStorage.metadisable != null) {
            $("#ArtMetadata :input").attr("disabled", true);
            $("#divLoadData :input").attr("disabled", true);
          }
          //Edit access details based on roles (Use the DisabledInutContorls)
          if (localStorage.metadataEdit == 'false') {
            $("#divArtInfo :input").attr("disabled", true);
            $("#divArticleModule :input").attr("disabled", true);
            $('#btnMetaUpdate').hide(); $('#btnReopen').hide();

            $(".skipDisabled :input").removeAttr("disabled");
          }

        });

        //if (!ArticleMetaComponent.pasteHtmlTextClear) {
        //  //Remove Html text paste from outside
        //  $(".jqte_editor").on("paste", function (e) {
        //    e.preventDefault();
        //    var text = e.originalEvent.clipboardData.getData('text');
        //    // insert copied data @ the cursor location
        //    document.execCommand("insertText", false, text);
        //    e.preventDefault();
        //    ArticleMetaComponent.pasteHtmlTextClear = true;
        //  });
        //}

      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "error");
      });
  }
  DisabledInutContorls() {
    if (localStorage.metadataEdit == 'false') {
      $("#divArtInfo :input").attr("disabled", true);
      $("#divArticleModule :input").attr("disabled", true);
      $('#btnMetaUpdate').hide(); $('#btnReopen').hide();

      $(".skipDisabled :input").removeAttr("disabled");
    }
  }
  hideInfoMetaDataModal() {
    if ($("#btnAutoRefreshDash").length > 0) {
      $("#btnAutoRefreshDash").trigger("click");
    }

    if (ArticleMetaComponent.unsaved) {
      ngswal({
        title: "Warning",
        text: "A change has been made in the page. Do you want to retain the change?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        closeOnConfirm: true,
        closeOnCancel: false
      },
        function (isConfirm) {
          if (isConfirm) {
            $('#btnMetaUpdate').trigger('click');

            $('#btnCloseMetapopup').trigger('click');
          }
          else {
            $('#btnCloseMetapopup').trigger('click');
            ngswal.close();
          }
        });
    }
    else {
      $('#btnCloseMetapopup').trigger('click');
    }

    $('a[href="#ArtStatus"]').trigger("click"); //Article Status Tab
    $('a[href="#Article"]').trigger("click"); //Article Status Article Tab
    $('a[href="#MainTab"]').trigger("click"); //Article Metada Main Tab
  }

  closeMetadataDetails() {
    this.showInfoMetadataModal = false;
    localStorage.removeItem('aEID'); localStorage.removeItem('metadisable');
  }

  ReopenArticlePopup() {
    this.showReopenModal = true;
    $('input[name="correction_type"]:checked').prop('checked', false);
    $('#ddlPublishedType').val('Select').change(); $('#ddlChangeVolIssue').val('Select').change();
  }
  hideReopenModal(): void {
    this.showReopenModal = false;
  }

  updateReopenDetails() {
    let corrTypeId = 0;
    if ($('#ddlPublishedType').val() == 'Select') {
      ngswal("Failed !", "Please select Article published status !", "warning");
    }
    else if ($('#ddlPublishedType').val() == 'false' && $('#ddlChangeVolIssue').val() == 'Select') {
      ngswal("Failed !", "Please select Vol-Issue change method !", "warning");
    }
    else if ($('#ddlPublishedType').val() == 'true' && $('input[name="correction_type"]:checked').length == 0) {
      ngswal("Failed !", "Please select Correction type !", "warning");
    }
    else if ($('#ddlChangeVolIssue').val() == 'true'
      && ($('#txtVolumeReopen').val() == 0 || $('#txtVolumeReopen').val() == '')
      && ($('#txtIssueReopen').val() == 0 || $('#txtIssueReopen').val() == '')) {
      ngswal("Failed !", "Please enter Volume/Issue details !", "warning");
    }
    else {
      if ($('input[name="correction_type"]:checked').length > 0) {
        corrTypeId = $('input[name="correction_type"]:checked').val().trim();
      }

      var articleData = {
        ArticleId: localStorage.aEID,
        IsArticlePublished: $('#ddlPublishedType').val(),
        IsChangeVolIssue: $('#ddlChangeVolIssue').val(),
        Volume: $('#txtVolumeReopen').val(),
        Issue: $('#txtIssueReopen').val(),
        CorrectionTypeId: corrTypeId,
        UpdatedBy: localStorage.aLoginID
      };
      $("#LoadingImageReopen").show();
      ApiMethod.postMethod(this.modelItem.UpdateReopenArticle, articleData).subscribe(
        result => {
          let itemL = result;
          if (itemL.indexOf('Failed') == -1) {
            localStorage.removeItem('metadisable'); $('#btnReopen').hide();
            this.hideReopenModal();
            ArticleinfoComponent.ArticleInfo(localStorage.aEID);
            this.PopuplateArticleMetada();
            if ($("#btnRefreshLoadData").length > 0) {
              $("#btnRefreshLoadData").trigger("click");
            }
            ngswal("Updated !", itemL, "success");
          }
          else {
            ngswal("warning !", itemL, "warning");
          }
          $("#LoadingImageReopen").hide();
        },
        error => {
          ngswal("Failed !", error.message, "warning");
          $("#LoadingImageReopen").hide();
        }
      );
    }
  }

  CheckPublishType() {
    if ($('#ddlPublishedType').val() == 'true') {
      $('#divCorrectionType').show();
      $('#divCheckVolIssue').hide();
    }
    else if ($('#ddlPublishedType').val() == 'false') {
      $('#divCheckVolIssue').show();
      $('#divCorrectionType').hide();

    }
  }

  CheckVolIssueChange() {
    $('#divVolIssueUpdate input').val('');
    if ($('#ddlChangeVolIssue').val() == 'true') {
      $('#divVolIssueUpdate').show();
    }
    else {
      $('#divVolIssueUpdate').hide();
    }
    $('#txtVolumeReopen,#txtIssueReopen').change(function () {
      $("#LoadingImageReopen").show();
      var aArticleItemL = {
        ArticleId: localStorage.aEID,
        Volume: $("#txtVolumeReopen").val(),
        Issue: $("#txtIssueReopen").val()
      }
      ApiMethod.postMethod(ArticleinfoComponent.modelItem.checkVolumeIssueApi, aArticleItemL).subscribe(
        response => {
          if (response.status == "Failed") {
            if (response.message.indexOf('volume') > 0) {
              $("#txtVolumeReopen").val('');
            }
            else if (response.message.indexOf('issue') > 0) {
              $("#txtIssueReopen").val('');
            }
            ngswal("Failed !", response.message, "error");
          }
          else {
            $("#TxtPopVolume").val($("#txtVolumeReopen").val());
          }
          $("#LoadingImageReopen").hide();
        },
        error => {
          ngswal("Failed !", error.error.Message, "warning");
          $("#LoadingImageReopen").hide();
        }
      );
    });

  }

}


